import { State } from '../types/state';

const resetUserGeoPosition = (state: State) => {
  state.geoPosition.geoCords = null;
};

export default resetUserGeoPosition;
